export default __webpack_public_path__ + "static/media/m-bg.3686ef66.png";